import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminAddBooks() {
  const [books, setBooks] = useState([]);
  const [courses, setCourses] = useState([]);
  const [title, setTitle] = useState('');
  const [pdf, setPdf] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [filterCourse, setFilterCourse] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const booksPerPage = 10;
  const navigate = useNavigate();
  useEffect(() => {
    const loadData = async () => {
      const coursesData = await fetchCourses();
      if (coursesData) {
        await fetchBooks(coursesData);
      } else {
        fetchBooks();
      }
    };
    loadData();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterCourse]);
  const fetchCourses = async () => {
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in.');
        return null;
      }
      const response = await axios.get(`${apiUrl}/api/admin/courses`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setCourses(response.data.courses);
        return response.data.courses;
      } else {
        setError(response.data.message || 'Failed to fetch courses.');
        return null;
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching courses.');
      return null;
    }
  };
  const fetchBooks = async (coursesData = courses) => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('You must be logged in to manage books.');
        setLoading(false);
        return;
      }
      const response = await axios.get(`${apiUrl}/api/admin/books`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        const booksWithCourse = response.data.books.map(book => ({
          ...book,
          coursename: coursesData.find(c => c.id === book.course_id)?.coursename || 'Unknown'
        }));
        setBooks(booksWithCourse);
      } else {
        setError(response.data.message || 'Failed to fetch books.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching books.');
    } finally {
      setLoading(false);
    }
  };
  const handlePdfChange = (e) => {
    setPdf(e.target.files[0]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const formData = new FormData();
    formData.append('title', title);
    formData.append('course_id', selectedCourse);
    formData.append('pdf', pdf);
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setError('Authentication required.');
        return;
      }
      const response = await axios.post(`${apiUrl}/api/admin/books`, formData, {
        headers: {
          Authorization: `Bearer ${sessionData.token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.data.success) {
        setSuccess('Book added successfully.');
        setTitle('');
        setPdf(null);
        setSelectedCourse('');
        fetchBooks();
      } else {
        setError(response.data.message || 'Failed to add book.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding book.');
    }
  };
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this book?')) {
      try {
        const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
        const response = await axios.delete(`${apiUrl}/api/admin/books/${id}`, {
          headers: { Authorization: `Bearer ${sessionData.token}` }
        });
        if (response.data.success) {
          fetchBooks();
        } else {
          setError(response.data.message || 'Failed to delete book.');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Error deleting book.');
      }
    }
  };
  

  // In AdminAddBooks.jsx - Update the handleView function
const handleView = (book) => {
  console.log('Book PDF path:', book.pdf);
  
  // Extract filename from the pdf path
  let filename = '';
  if (book.pdf) {
    if (book.pdf.includes('/')) {
      filename = book.pdf.split('/').pop();
    } else if (book.pdf.includes('\\')) {
      filename = book.pdf.split('\\').pop();
    } else {
      filename = book.pdf;
    }
  }
  
  console.log('Extracted filename:', filename);
  
  if (!filename) {
    alert('Error: Could not extract filename from PDF path');
    return;
  }

  // IMPORTANT: Use the SAME public endpoint that works for students
  // This assumes your public endpoint works and has access to all PDFs
  const pdfUrl = `${apiUrl}/api/public/pdf?file=${encodeURIComponent(filename)}`;
  
  console.log('Final PDF URL:', pdfUrl);
  
  // Navigate to admin view PDF page
  navigate('/admin-view-pdf', {
    state: {
      bookTitle: book.title,
      pdfUrl: pdfUrl,
      courseName: book.coursename
    }
  });
};



    // // Navigate to PDF viewer page with book data
    // navigate('/admin-view-pdf', {
    //   state: {
    //     bookTitle: book.title,
    //     pdfUrl: `${apiUrl}/api/proxy/pdf?file=${book.pdf.split('/').pop()}`,
    //     // pdfUrl: `${apiUrl}/api/proxy/pdf?url=${encodeURIComponent(apiUrl + book.pdf)}`,
    //     // pdfUrl: `${apiUrl}/api/proxy/pdf?url=${encodeURIComponent(book.pdf.startsWith('http') ? book.pdf : `${apiUrl}${book.pdf}`)}`,
    //     //1 pdfUrl: book.pdf.startsWith('http') ? book.pdf : `${apiUrl}${book.pdf}`,
    //     courseName: book.coursename
    //   }
    // });
  
  const filteredBooks = books.filter(book =>
    book.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (filterCourse ? book.course_id === parseInt(filterCourse) : true)
  );
  const isFiltered = searchTerm !== '' || filterCourse !== '';
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredBooks.length / booksPerPage); i++) {
    pageNumbers.push(i);
  }
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Manage Books</span>
                </li>
              </ul>
            </div>
            <div className="flex-align gap-8 flex-wrap">
              <div className="position-relative text-gray-500 flex-align gap-4 text-13">
                <span className="text-inherit">Sort by: </span>
                <div className="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                  <span className="text-lg">
                    <i className="ph ph-funnel-simple" />
                  </span>
                  <select className="form-control ps-8 pe-20 py-16 border-0 text-inherit rounded-4 text-center">
                    <option value="popular" selected>Popular</option>
                    <option value="latest">Latest</option>
                    <option value="trending">Trending</option>
                  </select>
                </div>
              </div>
              <div className="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                <span className="text-lg">
                  <i className="ph ph-layout" />
                </span>
                <select
                  className="form-control ps-8 pe-20 py-16 border-0 text-inherit rounded-4 text-center"
                  id="exportOptions"
                >
                  <option value="" selected disabled>
                    Export
                  </option>
                  <option value="csv">CSV</option>
                  <option value="json">JSON</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Add New Book</h4>
              {error && <div className="alert alert-danger mb-16">{error}</div>}
              {success && <div className="alert alert-success mb-16">{success}</div>}
              <form onSubmit={handleSubmit} encType="multipart/form-data" className="mb-24">
                <div className="mb-3">
                  <label htmlFor="course" className="form-label">Course</label>
                  <select
                    className="form-control"
                    id="course"
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                    required
                  >
                    <option value="">Select Course</option>
                    {courses.map(course => (
                      <option key={course.id} value={course.id}>{course.coursename}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="title" className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="pdf" className="form-label">PDF File</label>
                  <input
                    type="file"
                    className="form-control"
                    id="pdf"
                    accept="application/pdf"
                    onChange={handlePdfChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">Add Book</button>
              </form>
              <h4 className="mb-16">Book List</h4>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by title"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <select
                  className="form-control"
                  value={filterCourse}
                  onChange={(e) => setFilterCourse(e.target.value)}
                >
                  <option value="">All Courses</option>
                  {courses.map(course => (
                    <option key={course.id} value={course.id}>{course.coursename}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="card-body p-0 overflow-x-auto">
              {loading && (
                <div className="alert alert-info mb-0" role="alert">
                  Loading books...
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-0" role="alert">
                  {error}
                </div>
              )}
              {!loading && !error && filteredBooks.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  {isFiltered ? 'No books found.' : 'No books added.'}
                </div>
              )}
              {!loading && !error && filteredBooks.length > 0 && (
                <table id="bookTable" className="table table-striped">
                  <thead>
                    <tr>
                      <th className="fixed-width">
                        <div className="form-check">
                          <input
                            className="form-check-input border-gray-200 rounded-4"
                            type="checkbox"
                            id="selectAll"
                          />
                        </div>
                      </th>
                      <th className="h6 text-gray-300">Title</th>
                      <th className="h6 text-gray-300">Course</th>
                      <th className="h6 text-gray-300">Created</th>
                      <th className="h6 text-gray-300">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBooks.map((book) => (
                      <tr key={book.id}>
                        <td className="fixed-width">
                          <div className="form-check">
                            <input
                              className="form-check-input border-gray-200 rounded-4"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {book.title.length > 30
                              ? `${book.title.substring(0, 30)}...`
                              : book.title}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {book.coursename.length > 30
                              ? `${book.coursename.substring(0, 30)}...`
                              : book.coursename}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {new Date(book.created).toLocaleDateString()}
                          </span>
                        </td>
                        <td>
                          <button
                            onClick={() => handleView(book)}
                            className="bg-main-50 text-main-600 py-2 px-14 rounded-pill hover-bg-main-600 hover-text-white"
                          >
                            View
                          </button>
                          <button
                            onClick={() => handleDelete(book.id)}
                            className="bg-danger-50 text-danger-600 py-2 px-14 rounded-pill hover-bg-danger-600 hover-text-white ms-8"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer flex-between flex-wrap">
              <span className="text-gray-900">
                Showing {(currentPage - 1) * booksPerPage + 1} to {Math.min(currentPage * booksPerPage, filteredBooks.length)} of {filteredBooks.length} entries
              </span>
              <ul className="pagination flex-align flex-wrap">
                {pageNumbers.map(number => (
                  <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                    <a
                      onClick={() => setCurrentPage(number)}
                      className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                      href="#!"
                    >
                      {number}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminAddBooks;